import { Paw } from './Shapes';

/**
 * Wordmark "Cãopanhia" com a patinha no lugar do "o" — o mesmo detalhe do logo original.
 */
export const Wordmark = ({ className = '', pawClassName = 'text-white', circleClassName = 'bg-pet-pink-deep', withPet = false }) => (
  <span className={`font-display inline-flex items-baseline whitespace-nowrap leading-none ${className}`}>
    <span className="sr-only">Cãopanhia Pet</span>
    <span aria-hidden="true" className="inline-flex items-baseline">
      Cã
      <span className={`relative inline-block w-[0.62em] h-[0.62em] mx-[0.03em] rounded-full self-baseline translate-y-[0.04em] ${circleClassName}`}>
        <Paw className={`absolute inset-[18%] ${pawClassName}`} />
      </span>
      panhia
      {withPet && <span className="ml-[0.25em] text-pet-pink-deep">Pet</span>}
    </span>
  </span>
);

export default Wordmark;
